import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlipHorizontal2, FlipVertical2, RotateCcw, RotateCw } from 'lucide-react';

import { useMediaStudio } from '../../../../context/MediaStudioContext';
import { ELEMENT_TYPES } from '../../../../core/documentSchema';
import InspectorSection from '../inspector-section/InspectorSection';
import ToolButton from '../tool-button/ToolButton';
import ToolButtonGroup from '../tool-button/ToolButtonGroup';

import scss from './TransformSection.module.scss';

function TransformSection({ element }) {
  const { t } = useTranslation('mediaStudio');
  const { features, editor } = useMediaStudio();
  const isText = element.type === ELEMENT_TYPES.TEXT;

  return (
    <InspectorSection title={t('transform')}>
      <ToolButtonGroup>
        <ToolButton title={t('rotateCcw')} onClick={() => editor.rotateBy(element.id, -90)}>
          <RotateCcw size={16} />
        </ToolButton>
        <ToolButton title={t('rotateCw')} onClick={() => editor.rotateBy(element.id, 90)}>
          <RotateCw size={16} />
        </ToolButton>
        {!isText && features.flip ? (
          <>
            <ToolButton title={t('flipH')} onClick={() => editor.flipHorizontal(element.id)}>
              <FlipHorizontal2 size={16} />
            </ToolButton>
            <ToolButton title={t('flipV')} onClick={() => editor.flipVertical(element.id)}>
              <FlipVertical2 size={16} />
            </ToolButton>
          </>
        ) : null}
      </ToolButtonGroup>
      {!isText && features.aspectLock ? (
        <label className={scss.check}>
          <input
            type='checkbox'
            checked={element.keepAspectRatio}
            onChange={(event) => editor.change(element.id, { keepAspectRatio: event.target.checked })}
          />
          {t('keepAspectRatio')}
        </label>
      ) : null}
    </InspectorSection>
  );
}

export default TransformSection;
